import { render, staticRenderFns } from "./logistics.vue?vue&type=template&id=54564a4c&scoped=true"
import script from "./logistics.vue?vue&type=script&lang=js"
export * from "./logistics.vue?vue&type=script&lang=js"
import style0 from "./logistics.vue?vue&type=style&index=0&id=54564a4c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54564a4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54564a4c')) {
      api.createRecord('54564a4c', component.options)
    } else {
      api.reload('54564a4c', component.options)
    }
    module.hot.accept("./logistics.vue?vue&type=template&id=54564a4c&scoped=true", function () {
      api.rerender('54564a4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dataBoard/logistics.vue"
export default component.exports